<nav style=" background: linear-gradient(orange,  white);height: 65px;text-transform: uppercase;"
  class="navbar navbar-dark  ">

  <div class="navbar-expand mr-auto">
    <div class="navbar-nav" *ngIf="staff" >

        <a class="nav-item nav-link" routerLinkActive='active'     (click)="gotoProspect()"  >
          <img src="../assets/img/header/client.png" width="40" alt=""> ERP
        </a>
 
        <a class="nav-item nav-link" routerLinkActive='active'    *ngIf="roles.includes('client')"   routerLink="/client-list/CLIENTS/{{idUserCrypted}}">
          <img src="../assets/img/header/exposants.png" width="40" alt=""> Prospect Clients
        </a>
      <a class="nav-item nav-link" routerLinkActive='active'    *ngIf="roles.includes('exposant')"   routerLink="/client-list/E/{{idUserCrypted}}">
        <img src="../assets/img/header/exposants.png" width="40" alt=""> prospect exposants
      </a>

      <a class="nav-item nav-link" routerLinkActive='active'  *ngIf="roles.includes('delegue')"    routerLink="/client-list/D/{{idUserCrypted}}">
        <img src="../assets/img/header/delegue.png" width="40" alt="">prospect delegue
      </a>

 
      <a class="nav-item nav-link"  *ngIf="roles.includes('sponsor')"  routerLinkActive='active' routerLink="/client-list/S/{{idUserCrypted}}">
        <img src="../assets/img/header/sponsor.png" width="40" alt="">prospect sponsor
      </a>

 
    
 

    
      <a class="nav-item nav-link" *ngIf="roles.includes('floor')"  routerLinkActive='active' routerLink="/app-floor">
        <img src="../assets/img/header/floor.png" width="40" alt=""> Floor plan
      </a>
    
    
     
      <a class="nav-item nav-link" routerLinkActive='active' *ngIf="roles.includes('admin')"  routerLink="/admin">
        <img src="../assets/img/header/admin.png" width="40" alt=""> Admin
      </a>
 
 
   
    </div>
  

  </div>
     <a style="float: right;margin-right: 15px;cursor: pointer;" (click)="logout()" > 
             <img src="../assets/img/header/logout.png" width="40" alt="">  </a>
</nav>
 <div style="position: absolute;top: 77px;right: 30px;z-index: 999999;">
 
    <ul style="background: none;color: #2C3F91!important;" class="breadcrumb">
        <li *ngFor="let breadcrumb of breadcrumbs"
            class="breadcrumb-item">
          <a  style=" color: #2C3F91!important;"  routerLink="{{breadcrumb.url}}">
            {{ breadcrumb.label }}
          </a>
        </li>
      </ul>
 </div>
  <router-outlet></router-outlet>

 